import React from 'react';
import {
  formatDate,
  formatTime,
  formatDateTime,
  formatMonthYear,
} from 'common/helpers';
import moment from 'moment';

const Date: React.FC<{
  type?: 'date' | 'time' | 'dateTime' | 'monthYear';
  children: any;
}> = (props: { type?: string; children: any }) => {
  if (!props.children) {
    return <></>;
  }

  const date = moment(props.children).toDate();
  let result = <>{formatDate(date)}</>;

  switch (props.type) {
    case 'dateTime':
      result = <>{formatDateTime(date)}</>;
      break;
    case 'monthYear':
      result = <>{formatMonthYear(date)}</>;
      break;
    case 'time':
      result = <>{formatTime(date)}</>;
      break;
    default:
      break;
  }

  return result;
};

export default Date;
